import { Dispatch } from 'redux';

import { getIntegrationJobs as apiGetIntegrationJobs } from 'api/orgAdmin';
import { ApiOrgAdminIntegrationJob } from 'api/types/ApiOrgAdminIntegrationJob';
import { ApiOrgAdminIntegrationProvider } from 'api/types/ApiOrgAdminIntegrationProvider';

// Types

export type Integration = {
  isFetching: boolean;
  jobs?: Array<ApiOrgAdminIntegrationJob> | null | undefined;
};

export type Integrations = {
  jazzhr?: Integration;
  greenhouse?: Integration;
};

export type MainStoreOrgDashboardIntegrationsState = {
  byId: Record<string, Integrations>;
};

type FetchIntegrationAction = {
  type: 'FETCH_INTEGRATION_ACTION';
  integrationType: ApiOrgAdminIntegrationProvider;
  orgId: string;
};

type FetchIntegrationFailureAction = {
  type: 'FETCH_INTEGRATION_FAILURE_ACTION';
  integrationType: ApiOrgAdminIntegrationProvider;
  orgId: string;
};

type FetchIntegrationSuccessAction = {
  type: 'FETCH_INTEGRATION_SUCCESS_ACTION';
  integrationType: ApiOrgAdminIntegrationProvider;
  jobs: Array<ApiOrgAdminIntegrationJob> | null | undefined;
  orgId: string;
};

export type MainStoreOrgDashboardIntegrationsAction =
  | FetchIntegrationSuccessAction
  | FetchIntegrationAction
  | FetchIntegrationFailureAction;

// Reducer

const initialState = {
  byId: {},
};

export function integrationsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreOrgDashboardIntegrationsState = initialState,
  action: MainStoreOrgDashboardIntegrationsAction
) {
  switch (action.type) {
    case 'FETCH_INTEGRATION_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs:
          // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
          orgIntegrations && orgIntegrations[action.integrationType]
            ? // @ts-expect-error TS(2532): Object is possibly 'undefined'.
              orgIntegrations[action.integrationType].jobs
            : [],
        isFetching: true,
      };
      return {
        ...state,
        byId: { ...state.byId, [action.orgId]: orgIntegrations },
      };
    }

    case 'FETCH_INTEGRATION_FAILURE_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs: [],
        isFetching: false,
      };
      return {
        ...state,
        byId: { ...state.byId, [action.orgId]: orgIntegrations },
      };
    }

    case 'FETCH_INTEGRATION_SUCCESS_ACTION': {
      const orgIntegrations = { ...state.byId[action.orgId] };
      orgIntegrations[action.integrationType] = {
        jobs: action.jobs,
        isFetching: false,
      };
      return {
        ...state,
        byId: { ...state.byId, [action.orgId]: orgIntegrations },
      };
    }

    default:
      return state;
  }
}

// Actions

export const clearIntegrationJobs =
  (orgId: string, type: ApiOrgAdminIntegrationProvider) =>
  (dispatch: Dispatch<MainStoreOrgDashboardIntegrationsAction>) => {
    dispatch({
      type: 'FETCH_INTEGRATION_SUCCESS_ACTION',
      integrationType: type,
      orgId,
      jobs: null,
    });
  };
export const fetchIntegrationJobs =
  (orgId: string, type: ApiOrgAdminIntegrationProvider) =>
  (dispatch: Dispatch<MainStoreOrgDashboardIntegrationsAction>) => {
    dispatch({
      type: 'FETCH_INTEGRATION_ACTION',
      integrationType: type,
      orgId,
    });
    return apiGetIntegrationJobs(orgId, type)
      .then(({ jobs }) => {
        dispatch({
          type: 'FETCH_INTEGRATION_SUCCESS_ACTION',
          integrationType: type,
          orgId,
          jobs,
        });
        return jobs;
      })
      .catch((e) => {
        dispatch({
          type: 'FETCH_INTEGRATION_FAILURE_ACTION',
          integrationType: type,
          orgId,
        });
        return e;
      });
  };
